export const INVITATION_ACCEPTED_MESSAGE = "invitation_accepted";
